import { Component, Input, ViewChild, Renderer,
  EventEmitter, Output, forwardRef, ContentChild, AfterContentInit, ViewEncapsulation, ElementRef, AfterViewInit
} from '@angular/core';
import { FormControl, FormControlName, FormControlDirective, ControlValueAccessor, NG_VALUE_ACCESSOR, NgModel } from '@angular/forms';

let nextId = 0;
declare var jQuery: any;
declare var moment: any;

export class PuiDateChange {
  source: PuiDateComponent;
  value?: Date;
}

export const PUI_DATE_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => PuiDateComponent),
  multi: true
};

@Component({
  exportAs: 'puiInput',
  selector: 'pui-date',
  providers: [PUI_DATE_CONTROL_VALUE_ACCESSOR],
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./date.component.scss'],
  templateUrl: 'date.component.html'
})
export class PuiDateComponent implements AfterContentInit, AfterViewInit, ControlValueAccessor {
  @Input() id = `pui-date-${nextId++}`;
  @Input() label: string;
  @Input() placeholder = '';
  @Input() disabled: boolean;
  @Input() format = 'YYYY/MM/DD';
  // @Input() enableTimePicker: boolean;
  // @Input() timePickerIncrement = 30;
  @Input() minDate: Date;
  @Input() maxDate: Date;
  @Input() defaultDate: Date;

  @Output() change: EventEmitter<PuiDateChange> = new EventEmitter<PuiDateChange>();

  @ViewChild('input') input: ElementRef;
  @ContentChild(NgModel) ngModel: NgModel;
  @ContentChild(FormControlName) controlName: FormControlDirective;
  @ContentChild(FormControlDirective) controlDirective: FormControlDirective;

  /** @internal */
  _control: FormControl = new FormControl();
  private innerValue: Date = null;

  constructor(private renderer: Renderer) { }

  private onTouchedCallback: () => void = () => {};
  private onChangeCallback: (_: any) => void = () => {};

  ngAfterContentInit() {
    if (this.controlDirective) {
      this._control = this.controlDirective.control;
    } else if (this.controlName) {
      this._control = this.controlName.control;
    }
    if (this._control.disabled) {
      this.disabled = true;
    }
  }
  ngAfterViewInit() {
    let el = jQuery(this.input.nativeElement);
    el.datepicker({
      autoclose: true,
      todayHighlight: true,
      format: this.format.toLowerCase(),  // different convention from moment
      startDate: this.minDate,
      endDate: this.maxDate,
      forceParse: false
    });
    el.datepicker().on('changeDate', d => {
      this.value = d.date;
    });
    setTimeout(() => {
      // makes sure the picker has the value selected
      el.datepicker('setDate', this.ngModel ? this.ngModel.model : this.innerValue);
    });
  }

  get value() {
    return this.innerValue ? moment(this.innerValue).format(this.format) : this.defaultDate;
  }

  set value(v: any) {
    let emit = false;
    if (!v && this.innerValue) {
      this.innerValue = null;
      emit = true;
    } else if (v instanceof Date && (!this.innerValue || !moment(v).isSame(moment(this.innerValue)))) {
      // value is picked from the dropdown
      this.innerValue = v;
      emit = true;
    } else if (v && typeof v === 'string' && v === moment(v, this.format).format(this.format)) {
      // value is entered manually instead of picked
      // make sure it's entered in a valid format
      if (!this.innerValue || !moment(this.innerValue).isSame(moment(v, this.format))) {
        this.innerValue = moment(v, this.format).toDate();
        emit = true;
      }
    }
    if (emit) {
      this.onChangeCallback(this.innerValue);
      this.change.emit(<PuiDateChange>{
        source: this,
        value: this.innerValue
      });
    }
  }

  writeValue(v: any): void {
    // TODO: use moment.isSame() instead
    if (v !== this.innerValue) {
      this.innerValue = !v || v instanceof Date ? v : moment(v).format(this.format);
    }
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  _onBlur() {
    this.onTouchedCallback();
  }

  _iconClick(e: Event) {
    let el = jQuery(this.input.nativeElement);
    el.datepicker('show');
  }

  _onChange(e: any) {
    // will be captured & emit on date entered/picked
    e.stopPropagation();
  }

  _onEnter(e: KeyboardEvent): void {
    // TODO: check if the dropdown is open
    e.stopPropagation();
  }
}
